import { FarmerSalesIcon } from 'core/components/Icons'
import { Column, Table } from 'core/components/ui/Table'
import React from 'react'
import { EntityVolumeRow } from '../../../domain/entities/SalesReport'
import { SectionCard } from './SectionCard'
import { PAIRED_TABLE_BODY_HEIGHT, formatMT } from './format'

interface FarmerSalesTableProps {
  rows: EntityVolumeRow[]
  loading?: boolean
}

export const FarmerSalesTable: React.FC<FarmerSalesTableProps> = ({ rows, loading = false }) => {
  const columns: Column<EntityVolumeRow>[] = [
    {
      key: 'entityName',
      label: 'FPO',
      render: (row) => (
        <span className={row.isTotal ? 'font-extrabold text-text-primary' : 'font-semibold text-text-primary'}>
          {row.entityName}
        </span>
      ),
    },
    {
      key: 'units',
      label: 'No. of Units',
      render: (row) => (
        <span className={row.isTotal ? 'font-extrabold text-text-primary' : 'text-text-primary'}>{row.units}</span>
      ),
    },
    {
      key: 'mt',
      label: 'MT',
      render: (row) => (
        <span className={row.isTotal ? 'font-extrabold text-text-primary' : 'text-text-primary'}>
          {formatMT(row.mt)}
        </span>
      ),
    },
  ]

  return (
    <SectionCard title="Farmer Sales" subtitle="Units sold and volume moved, by FPO">
      <Table
        columns={columns}
        data={rows}
        loading={loading}
        emptyMessage="No farmer sales recorded."
        emptyIcon={<FarmerSalesIcon size={20} className="opacity-60" />}
        bodyHeight={PAIRED_TABLE_BODY_HEIGHT}
        stickyLastRow
      />
    </SectionCard>
  )
}
